/*
 * @Description: 全局数据类型
 * @Author: erickuang
 * @Date: 2021-08-25 20:57:40
 * @LastEditor: erickuang
 * @LastEditTime: 2021-09-22 20:34:52
 */
export interface DeviceInfo {
  system: string; // enum: "Android"、"iOS"
  brand: string; // 设备品牌名称，如："HUAWEI"
  systemVersion?: string; // 设备系统版本号，如"iOS 14.0.1"
  model?: string; // 设备机型，如："NOH-AN00"
  manufacturer?: string; // 设备厂商，如："HUAWEI"
  versionCode?: string; // 版本编号，如："60"
  deviceId?: string; // 设备 ID，可选
  imei?: string; // 设备 IMEI 号，可选
}
export interface InitialGlobalData {
  nativeVersion: string; // 客户端版本号（如：1.5.52）
  userId: string; // 用户 ID
  device: DeviceInfo;
}

export enum RouteChangeTransitionType {
  Normal,
  Reverse,
}

export enum NetworkType {
  Unknown,
  Wifi,
  Mobile2G,
  Mobile3G,
  Mobile4G,
  Mobile5G,
}
